import { MasterHoldMaintenanceConstant } from "presentation/constant/MasterHold/MasterHoldMaintenanceConstant";
import { useMasterHoldMaintenanceVM } from "presentation/hook/MasterHold/useMasterHoldMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMasterHoldMaintenanceTracked } from "presentation/store/MasterHold/MasterHoldMaintenanceProvider";
import { CommonMessageModal } from "presentation/view/components/CommonMessageModal";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const MasterHoldEditPanelTitleBar: React.FC = () => {
    const [masterHoldState] = useMasterHoldMaintenanceTracked();
    const masterHoldVM = useMasterHoldMaintenanceVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState, isShowSaveModal } = masterHoldState;
    const { editingEntity, isAdd, isEditable, isRead } = masterState;

    //const {isAdd: isCompAdd, isEditable: isCompEdit} = detailState;
    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowUpdate, operatingUnit } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isRead ? currentSelectedRow : editingEntity;


    const isDisable = () => {
        /*if (isCompAdd || (!isCompAdd && isCompEdit)) return true;*/

        return false;
    }

    const handleReset = useCallback(async () => {
        masterHoldVM.onResetClick();
    }, [masterHoldVM]);

    const handleEdit = useCallback(() => {
        masterHoldVM.onEdit(currentEntity);
    }, [currentEntity, masterHoldVM])

    const handleSaveResult = useCallback((res: any) => {
        if (res.error) {
            if (res.error.includes("EntityAlreadyExisted")) {
                if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
                    messageBarVM.showError('Duplicate record found, please check the key: Master Charge-On Company, Charge-On Company, Master Bill-To Company, Bill-To Company, Charge Type, Sub Charge Type, Ops Date From, Tar Type, Tar Code, Shipment Type, Ops Line, Target State.');
                }
                if (operatingUnit !== "SAPT" && operatingUnit !== "KICT") {
                    messageBarVM.showError('Duplicate record found, please check the key: Master Charge-On Company, Charge-On Company, Master Bill-To Company, Bill-To Company, Charge Type, Sub Charge Type, Ops Date From, Tar Type, Tar Code, Shipment Type, Target State.');
                }

            } else {
                messageBarVM.showError(res.error);
            }
            setIsLoading(false);
            return;
        }

        if (res.success) {
            messageBarVM.showSuccess("Save Successfully.");
            masterHoldVM.onCloseClick();
            masterHoldVM.searchMasterHold();
            setIsLoading(false);
        }
    }, [operatingUnit, messageBarVM, masterHoldVM]);

    const handleYes = useCallback(async () => {
        const res = await masterHoldVM.onPromptBoxYesClick(currentEntity);
        handleSaveResult(res);
    }, [currentEntity, handleSaveResult, masterHoldVM])

    const handleNo = useCallback(async () => {
        const res = await masterHoldVM.onSave(currentEntity, isAdd);
        handleSaveResult(res);
        masterHoldVM.onPromptBoxNoClick();
    }, [currentEntity, handleSaveResult, isAdd, masterHoldVM])

    const handleCancel = useCallback(() => {
        masterHoldVM.onPromptBoxCancelClick();
    }, [masterHoldVM])

    const handleClose = useCallback(() => {
        if (isAdd || isRead) {
            masterHoldVM.onCloseClick();
        }
        if (isEditable && !isRead) {
            masterHoldVM.onCloseEdit();
        }
    }, [isAdd, isEditable, isRead, masterHoldVM])

    const handleSave = useCallback(async () => {
        // if (!currentEntity.effectiveDate) {
        //     messageBarVM.showError('Ops Date From is mandatory.');
        //     return;
        // }
        // if (!currentEntity.target) {
        //     messageBarVM.showError('Target State is mandatory.');
        //     return;
        // }
        if (currentEntity.effectiveDate && currentEntity.expiryDate && new Date(currentEntity.expiryDate) < new Date(currentEntity.effectiveDate)) {
            messageBarVM.showError("The Ops Date To should be later than the Ops Date From.");
            return false;
        }
        setIsLoading(true);
        try {
            masterHoldVM.onSaveClicked();
            if (isAdd) {
                const res = await masterHoldVM.onSave(currentEntity, isAdd);
                if (res && !res.success) {
                    if (res.data.includes("EntityAlreadyExisted")) {
                        if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
                            messageBarVM.showError('Duplicate record found, please check the key: Master Charge-On Company, Charge-On Company, Master Bill-To Company, Bill-To Company, Charge Type, Sub Charge Type, Ops Date From, Tar Type, Tar Code, Shipment Type, Ops Line, Target State.');
                        }
                        if (operatingUnit !== "SAPT" && operatingUnit !== "KICT") {
                            messageBarVM.showError('Duplicate record found, please check the key: Master Charge-On Company, Charge-On Company, Master Bill-To Company, Bill-To Company, Charge Type, Sub Charge Type, Ops Date From, Tar Type, Tar Code, Shipment Type, Target State.');
                        }
                        setIsLoading(false)
                    } else {
                        messageBarVM.showError(res.data);
                        setIsLoading(false)
                    }
                    return;
                } else if (res.success) {
                    messageBarVM.showSuccess("Save Successfully.");
                    masterHoldVM.onCloseClick();
                    await masterHoldVM.searchMasterHold();

                    setIsLoading(false)
                }
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isAdd, masterHoldVM, messageBarVM, operatingUnit]);

    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: MasterHoldMaintenanceConstant.CATEGORY }, { title: MasterHoldMaintenanceConstant.Header.TITLE }]} onCurrentClick={() => { }}></HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {(!isAdd && (isEditable && isRead)) &&
                <>
                    {/* Edit Button */}
                    {
                        (
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                    }
                    {/* Close Button */}
                    <IconButton fileName='Icon-cross' size='medium' toolTipText={'Close'} toolTipArrow={false} onClick={masterHoldVM.onCloseClick} />
                </>}
            {(isAdd || (isEditable && !isRead)) &&
                <>
                    {/* Reset Form Button */}
                    <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />
                    {/* Close Button */}
                    <IconButton fileName="Icon-cross" size="medium" disabled={isDisable()} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={handleClose} />
                    {/* Save Button */}
                    {
                        (
                            (isAdd && allowCreate) ||
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName="Icon-tick" size="medium" disabled={isDisable()} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                    }
                </>}
            <CommonMessageModal headerText={MasterHoldMaintenanceConstant.Header.TITLE}
                contentText={'Would you like to release all charge data held by this master hold?'}
                visible={isEditable && !isRead && isShowSaveModal}
                footerButtons={[
                    { label: 'Cancel', theme: 'Secondary', onClick: handleCancel },
                    { label: 'No', theme: 'Secondary', onClick: handleNo },
                    { label: 'Yes', theme: 'Primary', onClick: handleYes },
                ]}
            />
        </StyledAction>
    </Sidebarheader>
}

export default memo(MasterHoldEditPanelTitleBar);